<div class="cubejs-actions">
  <div class="cubejs-form-block row">
    <!-- START DATE -->
    @if (userWantsCustomDateRange) {
      <div class="start-date">
        <dp-date-picker
          [(ngModel)]="startDateFilter"
          [config]="startDatePickerConfig"
          mode="day"
          required
          (onChange)="onChangeCustomDate($event)">
        </dp-date-picker>
      </div>
    }
    <!-- END DATE -->
    @if (userWantsCustomDateRange) {
      <div class="end-date">
        <dp-date-picker
          [(ngModel)]="endDateFilter"
          [config]="endDatePickerConfig"
          mode="day"
          required
          (onChange)="onChangeCustomDate($event)">
        </dp-date-picker>
        @if (!isValidDateRange) {
          <div class="alert alert-danger">
            {{'error.endDateBeforeStartDate' | translate}}
          </div>
        }
      </div>
    }
    <app-select [config]="selectConfig" (selectionChange)="onDateRangeChange($event)"></app-select>
  </div>
</div>